import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CheckIcon from 'mdi-react/CheckIcon';
import CheckAllIcon from 'mdi-react/CheckAllIcon';
import moment from 'moment';
import classNames from 'classnames';
import { util } from '../../../../shared/util';


class ChatBubble extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    active: PropTypes.bool,
  };

  static defaultProps = {
    active: false,
  };

  render() {
    const { contact, message, active } = this.props;
    const bubbleClass = classNames({
      chat__bubble: true,
      'chat__bubble--active': active,
    });

    let data = util.formatDateToStringChat(message.date, moment(message.date).format('LT'));

    let alertNew = '';
    let msg = '';
    let view = [];
    let icoRead = '';
    let name = '';
    let avatar = '';

    if(contact !== null && avatar !== undefined){
      name = contact.name;
      avatar = contact.avatar;
    }

    icoRead = <CheckIcon style={{width: '14px', marginLeft: '2px'}} />
    if(message.read){
      icoRead = <CheckAllIcon style={{width: '14px', marginLeft: '2px', color: '#3178fb'}} />
    }else if(message.received){
      icoRead = <CheckAllIcon style={{width: '14px', marginLeft: '2px'}} />
    }

    if(active){
      if(message.file){
        msg = <div key={"messageF"+message.id} className="chat__bubble-message-wrap chat__bubble-message-wrap--file">
                <p className="chat__bubble-contact-name">{name}</p>
                <img src={message.file.preview} alt={message.message} />
                <p className="chat__bubble-date">{data}</p>
                <div className="chat__bubble-download-wrap">
                  <p className="chat__bubble-file-name">
                    <span>{message.message}</span>
                    <span>{message.file.size}</span>
                  </p>
                  <a className="chat__bubble-download" href={message.file.preview} download>Download</a>
                </div>
              </div>
      }else{
        msg = <div key={"messageT"+message.id} className="chat__bubble-message-wrap">
                <p className="chat__bubble-contact-name">{name}</p>
                <p className="chat__bubble-message">{message.message}</p>
                <p className="chat__bubble-date" style={{right: '55px'}}>
                  {data}
                  {icoRead}
                </p>
              </div>
      }
      view.push(msg);
      view.push(
                <div key={"message"+message.id} className="chat__bubble-avatar">
                  <img src={avatar} alt="ava" />
                </div>
      );
    }else{
      if(message.file){
        msg = <div key={"messageF"+message.id} className="chat__bubble-message-wrap chat__bubble-message-wrap--file">
                <p className="chat__bubble-contact-name">{name}</p>
                <img src={message.file.preview} alt={message.message} />
                <p className="chat__bubble-date">{data}</p>
                <div className="chat__bubble-download-wrap">
                  <p className="chat__bubble-file-name">
                    <span>{message.message}</span>
                    <span>{message.file.size}</span>
                  </p>
                  <a className="chat__bubble-download" href={message.file.preview} download>Download</a>
                </div>
              </div>
      }else{
        msg = <div key={"messageT"+message.id} className="chat__bubble-message-wrap">
                <p className="chat__bubble-contact-name">{name}</p>
                <p className="chat__bubble-message">{message.message}</p>
                <p className="chat__bubble-date" style={{right: '55px'}}>
                  {data}
                  {icoRead}
                </p>
              </div>
      }

      view.push(
        <div key={"message"+message.id} className="chat__bubble-avatar">
          <img src={avatar} alt="ava" />
        </div>
      );

      if(message.newMessages){
        alertNew = <div key={"messageAlertNew1"+message.id} className="topbar__btn topbar__btn--new">
                    <div  key={"messageAlertNew2"+message.id} className="topbar__btn-new-label"><div /></div>
                  </div>
        
        view.push(alertNew);
      }
      view.push(msg);
    }

    return (
      <div className={bubbleClass}>
        {view}
      </div>
    );
  }
}
export default withTranslation('common')(ChatBubble);